import { useState } from "react";
import React from 'react'
import { NavLink } from "react-router-dom"
import './style.css'


const Form = ({title,handleClick}) => {
    const [email,setEmail] = useState('');
    const [pass,setPass] = useState('');
    const [name, setName] = useState('');
    let check = false;
    function checkForm(){
      if(title === "Регистрация"){
        check = false;
        console.log(check);
      }
      else if(title === "Вход"){
        check = true;
      }
    }
 
    checkForm();
  return (
    <div>
<div class='bold-line'></div>
<div class='container'>
  <div class='window'>
    <div class='overlay'></div>
    <div class='content'>
      <div class='welcome'>Добро пожаловать!</div>
        {check? 
         <div class='subtitle'>У вас еще нет аккаунта? <NavLink to={"/reg"}>Зарегистрироваться</NavLink>  </div>
      
        :
        <div class='subtitle'>У вас есть аккаунт? <NavLink to={"/log"} > Войти</NavLink> </div>
        }
     
      <div class='input-fields'> 
        {check ?
        <div>
         <input type='email' value={email} onChange={(e) => setEmail(e.target.value)}  placeholder='Почта' class='input-line full-width'></input>
         <input type='password' value={pass} onChange={(e) => setPass(e.target.value)}  placeholder='Пароль' class='input-line full-width'></input>
        </div>
        :
        <div>
          <input type='name' value={name} onChange={(e) => setName(e.target.value)} placeholder='Никнейм' class='input-line full-width'></input>
         <input type='email' value={email} onChange={(e) => setEmail(e.target.value)}  placeholder='Почта' class='input-line full-width'></input>
         <input type='password' value={pass} onChange={(e) => setPass(e.target.value)}  placeholder='Пароль' class='input-line full-width'></input>
      </div>
        }
      </div>
      <div><button onClick={() => handleClick(email,pass,name)} class='ghost-round full-width'>{title}</button></div>
    </div>
  </div>
</div>
    </div>
  )
}

export  {Form}